import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "filter-mobile" }
const _hoisted_2 = { key: 0 }

import FilterTagList from '@lmt-rpb/FilterTagList/FilterTagList.vue';
import ListFilters from '@lmt-rpb/ListFilters/ListFilters.vue';
import FilterContainer from '@lmt-rpb/FilterContainer/FilterContainer.vue';
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { getOS } from '@/js/utils/environmentUtils';
import { useFilters } from 'src/composables/useFIlters';

type Props = {
	listType: 'hotel' | 'region' | 'offer';
	destinationLabel?: string;
};

const selector = 'dialog.search-modal[open]';
const filterTagListSelector = '.filter-mobile > .filter-container';

export default /*@__PURE__*/_defineComponent({
  __name: 'FilterMobile',
  props: {
    listType: {},
    destinationLabel: {}
  },
  setup(__props: any) {

const { activeFilters: filters } = useFilters();



const lastKnownHeight = ref(0);
let observer: MutationObserver | null = null;

function getHeight(): number {
	const element = document.querySelector(filterTagListSelector);
	if (!element) return 0;

	const computedStyle = getComputedStyle(element);
	const marginTop = parseFloat(computedStyle.marginTop) || 0;
	const marginBottom = parseFloat(computedStyle.marginBottom) || 0;

	// Dynamically include margin changes in the height calculation
	return element.clientHeight + marginTop + marginBottom;
}

function adjustScroll(delta: number) {
	const { isiOS } = getOS();
	if (!isiOS) {
		return;
	}
	const scrollContainer = document.querySelector(selector + ' .search-modal__main');
	if (scrollContainer) {
		scrollContainer.scrollTop += delta;
	}
}

onMounted(() => {
	nextTick(() => {
		const targetNode = document.querySelector(filterTagListSelector);
		if (targetNode) {
			lastKnownHeight.value = getHeight();

			observer = new MutationObserver(() => {
				const newHeight = getHeight();
				const delta = newHeight - lastKnownHeight.value;

				// Adjust scroll for both height increase and decrease
				if (delta !== 0) {
					adjustScroll(delta);
				}

				lastKnownHeight.value = newHeight;
			});

			observer.observe(targetNode, { childList: true, subtree: true, attributes: true });
		}
	});
});

onBeforeUnmount(() => {
	if (observer) {
		observer.disconnect();
		observer = null;
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FilterContainer, { "with-divider": false }, {
      default: _withCtx(() => [
        (_unref(filters).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(FilterTagList, {
                "emit-analytics": false,
                "show-reset-in-header": true,
                "is-modal": true
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(ListFilters, {
      filters: _unref(filters),
      "has-filters": _unref(filters).length > 0,
      "list-type": _ctx.listType,
      "destination-label": _ctx.destinationLabel
    }, null, 8 /* PROPS */, ["filters", "has-filters", "list-type", "destination-label"])
  ]))
}
}

})